import {
  MegaMenuGridWrapper,
  NavigationCard,
  SecondaryPlpNav,
} from '@time-line/components/common';
import type { SubNav } from '@time-line/components/types';
import { BlogCard } from 'components/blog/BlogCard';
import { BannerCard } from 'components/common/BannerCard';
import { ProductCard } from 'components/product/ProductCard';
import { useProductCollection } from 'hooks/product/useProductCollection';
import { useGlobals } from 'hooks/useGlobals';
import { useIsSkincare } from 'hooks/useIsSkincare';
import { SCIENCE_PAGE_MAP } from 'lib/constants/navigation';
import { getTrackingId } from 'utils/getTrackingId';

export function SecondaryContent({ subNav }: { subNav: SubNav }) {
  const { data: globals } = useGlobals();
  const secondaryPlpPages = globals?.siteSettings?.secondaryPlpMenu;
  const navigationProducts = useProductCollection(
    globals?.siteSettings?.featuredProducts,
  );
  const isSkincare = useIsSkincare();

  if (!globals) {
    return null;
  }

  switch (subNav.contentType) {
    case 'posts':
      return globals.posts.map((post) => (
        <MegaMenuGridWrapper key={post._id}>
          <BlogCard
            type={post.type}
            title={post.title}
            image={post.heroImage}
            videoUrl={post.heroVideoUrl}
            slug={post.slug}
            categories={post.categories}
            publishedAt={post.publishedAt}
          />
        </MegaMenuGridWrapper>
      ));
    case 'products':
      return (
        <>
          {secondaryPlpPages && (
            <MegaMenuGridWrapper>
              <SecondaryPlpNav secondaryPlpMenu={secondaryPlpPages} />
            </MegaMenuGridWrapper>
          )}
          {navigationProducts.map((product, i) => (
            <MegaMenuGridWrapper key={i}>
              <ProductCard
                index={i}
                collectionName="main"
                {...product}
                isDoctorRecommended={false}
              />
            </MegaMenuGridWrapper>
          ))}
          {!isSkincare && (
            <MegaMenuGridWrapper>
              <BannerCard />
            </MegaMenuGridWrapper>
          )}
        </>
      );
    case 'science': {
      const navigationCards =
        globals.siteSettings.scienceNav?.navigationCards ?? [];
      const scienceCards = navigationCards
        .map((card, i) => {
          const navItem = SCIENCE_PAGE_MAP[card.link._id];
          if (!navItem) return null;
          return (
            <MegaMenuGridWrapper key={i}>
              <NavigationCard
                href={navItem.href}
                label={navItem.label}
                id={getTrackingId(`${navItem.name}_card`, {
                  platform: 'desktop',
                  parent: 'header',
                })}
                image={card.image}
                isDividerVisible={false}
                titlePosition="bottom"
              />
            </MegaMenuGridWrapper>
          );
        })
        .filter(Boolean);

      return scienceCards;
    }
    default:
      return null;
  }
}
